import Log from 'utils/Log';

const crashReporter = () => next => action => {
  try {
    return next(action);
  } catch (error) {
    Log.error(error, `Caught an exception (${action.type}).`);
    return undefined;
  }
};

export default crashReporter;
